import React from "react";

interface BaseIconProps {
  isActive?: boolean;
  className?: string;
}

export default function TakeBackIcon({ isActive, className }: BaseIconProps) {
  return (
    <svg
      width="33"
      height="33"
      className={className}
      viewBox="0 0 33 34"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M24.065 7.83337H14.8658C13.0624 7.83337 11.333 8.57965 10.0578 9.90803C8.78268 11.2364 8.06631 13.0381 8.06631 14.9167V24.5H6.06647C4.68746 24.5 3.36492 23.9294 2.38981 22.9135C1.4147 21.8977 0.86689 20.52 0.86689 19.0834V5.75004C0.86689 4.31345 1.4147 2.9357 2.38981 1.91988C3.36492 0.904057 4.68746 0.333374 6.06647 0.333374H18.8654C20.2445 0.333374 21.567 0.904057 22.5421 1.91988C23.5172 2.9357 24.065 4.31345 24.065 5.75004V7.83337ZM32.8643 28.25C32.8643 28.9614 32.7298 29.6657 32.4685 30.3229C32.2072 30.9801 31.8242 31.5772 31.3414 32.0802C30.8586 32.5832 30.2854 32.9822 29.6545 33.2544C29.0237 33.5266 28.3476 33.6667 27.6647 33.6667H14.8658C14.183 33.6667 13.5068 33.5266 12.876 33.2544C12.2451 32.9822 11.6719 32.5832 11.1891 32.0802C10.7063 31.5772 10.3233 30.9801 10.062 30.3229C9.80068 29.6657 9.66619 28.9614 9.66619 28.25V14.9167C9.66619 13.4801 10.214 12.1024 11.1891 11.0865C12.1642 10.0707 13.4868 9.50004 14.8658 9.50004H27.6647C28.3476 9.50004 29.0237 9.64015 29.6545 9.91236C30.2854 10.1846 30.8586 10.5836 31.3414 11.0865C31.8242 11.5895 32.2072 12.1867 32.4685 12.8438C32.7298 13.501 32.8643 14.2054 32.8643 14.9167V28.25ZM27.6647 31.1667C28.4073 31.1667 29.1194 30.8594 29.6445 30.3124C30.1695 29.7655 30.4645 29.0236 30.4645 28.25V14.9167C30.4645 14.1432 30.1695 13.4013 29.6445 12.8543C29.1194 12.3073 28.4073 12 27.6647 12H14.8658C14.1232 12 13.4111 12.3073 12.886 12.8543C12.361 13.4013 12.066 14.1432 12.066 14.9167V28.25C12.066 29.86 13.3203 31.1667 14.8658 31.1667H27.6647Z"
        fill={isActive ? "#663399" : "#000"}
      />
    </svg>
  );
}
